export default __webpack_public_path__ + "static/media/break25.06e71a0b.jpg";